import React, { useState, useEffect } from "react";
import { Box, Paper, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import SidebarMenu from "./AdminPanel/SidebarMenu";
import TopBar from "./AdminPanel/TopBar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClienteData from "./ProformaForm/ClienteData";
import ProductData from "./ProformaForm/ProductData";
import DetailsData from "./ProformaForm/DetailsData";
import Descripcion from "./ProformaForm/Descripcion";

const Proforma = () => {
  const [cliente, setCliente] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [contacto, setContacto] = useState("");
  const [direccionCliente, setDireccionCliente] = useState("");
  const [descripcionProforma, setDescripcionProforma] = useState("");

  const [productoData, setProductoData] = useState(null);

  const [detailsData, setDetailsData] = useState({
    validez: "",
    cobro: "",
    entrega: "",
    garantia: "",
    referencia: ""
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  const totalProductos = productoData?.total ? parseFloat(productoData.total) : 0;
  const totalProforma = totalProductos;

  useEffect(() => {
    if (!id) return;

    fetch(`/proformas/detalle-proforma/${id}/`, { credentials: "include" })
      .then((resp) => resp.json())
      .then((data) => {
        if (data?.error) return;

        setCliente(data.cliente || "");
        setIdentificacion(data.identificacion_cliente || "");
        setEmail(data.email || "");
        setTelefono(data.telefono || "");
        setContacto(data.contacto || "");
        setDireccionCliente(data.direccion || "");
        setDescripcionProforma(data.descripcion_proforma || "");

        setDetailsData({
          validez: data.validez || "",
          cobro: data.cobro || "",
          entrega: data.entrega || "",
          garantia: data.garantia || "",
          referencia: data.referencia || ""
        });
      })
      .catch(() => {});
  }, [id]);

  function getCookie(name) {
    let cookieValue = null;
    if (document.cookie) {
      const cookies = document.cookie.split(";");
      for (let cookie of cookies) {
        const [key, val] = cookie.trim().split("=");
        if (key === name) {
          cookieValue = decodeURIComponent(val);
          break;
        }
      }
    }
    return cookieValue;
  }

  const handleDetailsChange = (field, value) =>
    setDetailsData((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async () => {
    const hasProductos = productoData?.productos?.length > 0;

    if (!cliente || !identificacion || !hasProductos) {
      setErrorMessage("Debe seleccionar cliente y al menos un producto.");
      return;
    }

    const csrftoken = getCookie("csrftoken");

    const response = await fetch("/proformas/crear-proforma/", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrftoken
      },
      body: JSON.stringify({
        cliente,
        identificacion_cliente: identificacion,
        contacto,
        email,
        telefono,
        direccion: direccionCliente,
        descripcion_proforma: descripcionProforma,
        descripcion: productoData?.descripcion || "",
        producto: productoData,
        detalles: {
          validez: detailsData.validez,
          cobro: detailsData.cobro,
          entrega: detailsData.entrega,
          garantia: detailsData.garantia,
          referencia: detailsData.referencia,
          total: totalProforma
        }
      })
    });

    const data = await response.json();

    if (response.ok) {
      setCliente("");
      setIdentificacion("");
      setEmail("");
      setTelefono("");
      setContacto("");
      setDireccionCliente("");
      setDescripcionProforma("");
      setProductoData(null);
      setDetailsData({
        validez: "",
        cobro: "",
        entrega: "",
        garantia: "",
        referencia: ""
      });
      navigate("/admin-panel/proformas", { state: { created: true } });
    } else {
      setErrorMessage(data.error || "Error al crear proforma.");
    }
  };

  const handlePreview = () => {
    const params = new URLSearchParams();

    params.append("cliente", cliente || "");
    params.append("identificacion", identificacion || "");
    params.append("email", email || "");
    params.append("telefono", telefono || "");
    params.append("contacto", contacto || "");
    params.append("direccion", direccionCliente || "");
    params.append("descripcion_proforma", descripcionProforma || "");

    params.append("validez", detailsData.validez || "");
    params.append("cobro", detailsData.cobro || "");
    params.append("entrega", detailsData.entrega || "");
    params.append("garantia", detailsData.garantia || "");
    params.append("referencia", detailsData.referencia || "");
    params.append("descripcion", productoData?.descripcion || "");

    const toPct = (p) => {
      const pctNum =
        typeof p.descuentoPct === "number" ? p.descuentoPct : parseFloat(p.descuentoPct);
      if (!Number.isNaN(pctNum)) return pctNum;
      const desc = parseFloat(p.descuento);
      const price = parseFloat(p.pvp);
      if (!Number.isNaN(desc) && !Number.isNaN(price) && price > 0) return (desc / price) * 100;
      return 0;
    };

    const safe = (v) => String(v ?? "").replaceAll("|", "-").replaceAll("~", "-");

    if (productoData?.productos?.length) {
      const prodStrings = productoData.productos.map((p) =>
        [
          safe(p.codigo_principal || ""),
          safe(p.codigo_auxiliar || ""),
          safe(p.descripcion || p.detalle || ""),
          safe(p.detalles || p.brand || ""),
          safe(p.pvp),
          safe(p.cantidad),
          safe(p.imagen || "None"),
          safe(toPct(p)),
          safe(p.iva_porcentaje ?? "")
        ].join("|")
      );
      params.append("productos", prodStrings.join("~"));
    }

    window.open(`/proformas/vista-previa-proforma/?${params.toString()}`, "_blank");
  };

  const handleLogout = async () => {
    await fetch("/sistema/logout/", { method: "POST", credentials: "include" });
    localStorage.clear();
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      <SidebarMenu
        open={open}
        setOpen={setOpen}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        navigate={navigate}
        handleLogout={handleLogout}
      />
      <Box sx={{ flexGrow: 1 }}>
        <TopBar open={open} setOpen={setOpen} />
        <Box sx={{ width: "95%", mx: "auto", mt: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 3 }}>
            <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              sx={{
                textTransform: "none",
                backgroundColor: "#1565C0",
                borderRadius: 2,
                px: 2.2,
                fontWeight: 700,
                boxShadow: "0 8px 20px rgba(21,101,192,0.22)",
              }}
              onClick={() => navigate(-1)}
            >
              Regresar
            </Button>
          </Box>

          <Box sx={{ display: "grid", gap: 3, gridTemplateColumns: "1fr" }}>
            <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
              <ClienteData
                cliente={cliente}
                identificacion={identificacion}
                email={email}
                telefono={telefono}
                contacto={contacto}
                direccion={direccionCliente}
                onClienteDataChange={(data) => {
                  setCliente(data.cliente);
                  setIdentificacion(data.identificacion_cliente);
                  setEmail(data.email);
                  setTelefono(data.telefono);
                  setContacto(data.contacto);
                  setDireccionCliente(data.direccion);
                }}
              />
            </Paper>

            <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
              <ProductData onProductDataChange={setProductoData} />
            </Paper>

            <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
              <Descripcion
                descripcionProforma={descripcionProforma}
                onDescripcionChange={setDescripcionProforma}
              />
            </Paper>

            <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
              <DetailsData {...detailsData} onFieldChange={handleDetailsChange} total={totalProforma} />
            </Paper>

            {errorMessage && (
              <Typography color="error" align="center">
                {errorMessage}
              </Typography>
            )}

            <Box display="flex" justifyContent="center" mt={2} gap={2} mb={2}>
              <Button variant="outlined" onClick={handlePreview}>
                Vista Previa
              </Button>
              <Button variant="contained" onClick={handleSubmit} sx={{ backgroundColor: "#1565C0" }}>
                Guardar Proforma
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Proforma;